/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('global/GoogleAnalytics',[
    'jquery',
    'lodash',
    './GoogleAnalyticsAmd',
    './Logger'
], function ($, _, ga, Logger) {
    'use strict';

    var cfg = window.RocConfig;
    var ecPluginLoaded = false;
    var trackingId = cfg.google.analyticsTrackingId;

    /**
     * ensureEcommercePlugin() returns a boolean
     * based on if Enhanced Ecommerce plugin is loaded
     * if not, it loads the plugin and returns true
     *
     * @return {boolean} ecPluginLoaded
     */
    function ensureEcommercePlugin() {
        if ((cfg.google && cfg.google.isEnhancedCommerce && cfg.google.enableAnalyticsTracking) && trackingId && !ecPluginLoaded) {
            Logger.debug('Google Analytics Enhanced Ecommerce is enabled');
            ga('require', 'ec');
            ecPluginLoaded = true;
        }

        return ecPluginLoaded;
    }

    // Check to see if EC plugin is needed on load
    $(function () {
        ensureEcommercePlugin();
    });

    /**
     * setBannerImpression() Sends an event to GA
     * based on the passed model to measure a banner impression
     *
     * @param {object} model
     */
    function setBannerImpression(model) {
        if (ensureEcommercePlugin()) {
            ga('ec:addPromo', {
                'id': model.id,
                'name': model.name
            });

            ga('send', 'event', 'banner', 'impression', model.name, { 'nonInteraction': 1 });
        }
    }

    /**
     * setBannerClick() Sends an event to GA
     * based on the passed model to measure a click
     *
     * @param {object} model
     */
    function setBannerClick(model) {
        if (ensureEcommercePlugin()) {
            // Identify the promotion that was clicked.
            ga('ec:addPromo', {
                'id': model.id,
                'name': model.name
            });

            // Send the promo_click action with an event.
            ga('ec:setAction', 'promo_click');
            ga('send', 'event', 'banner', 'click', model.name);
        }
    }

    // tracking methods

    /**
     * setImpression() Sends an event to GA
     * based on the passed model to measure a product view impression
     *
     * @param {object} model
     */
    function setImpression(model) {
        if (ensureEcommercePlugin()) {
            var productObject = {
                'name': model.name,
                'list': model.list,
                'position': model.position
            }

            // If id is provided in model, include the passed id
            if (model.id) {
                productObject.id = model.id;
            }

            Logger.log("GA DEBUG: ", productObject);

            ga('ec:addImpression', productObject);
            ga('send', 'event', 'ecommerce', 'impression', 'Product', { 'nonInteraction': 1 });
        }
    }

    /**
     * setProductClick() Sends an event to GA
     * based on the passed model to measure a click on a product from a list
     *
     * @param {object} model
     */
    function setProductClick(model) {
        if (ensureEcommercePlugin()) {
            var productObject = {
                'name': model.name,
                'position': model.position
            }

            // If id is provided in model, include the passed id
            if (model.id) {
                productObject.id = model.id;
            }

            ga('ec:addProduct', productObject);
            ga('ec:setAction', 'click', { list: model.list });
            ga('send', 'event', 'ecommerce', 'click', 'Results');
        }
    }

    //Measuring a Product Details View
    function setImpressionDetailed(model, isInteraction) {
        if (ensureEcommercePlugin()) {
            var productObject = {
                'name': model.name,
            }

            // If id is provided in model, include the passed id
            if (model.id) {
                productObject.id = model.id;
            }

            ga('ec:addProduct', productObject);
            ga('ec:setAction', 'detail');

            // if event is triggered by user interaction send GA event normally. Otherwise pass event with GA nonInteraction property
            if (isInteraction) {
                ga('send', 'event', 'ecommerce', 'impression', 'Product Details');
            } else {
                ga('send', 'event', 'ecommerce', 'impression', 'Product Details', { 'nonInteraction': 1 });
            };
        }
    }

    /**
     * sendCartTransaction() sends event related to cart
     *
     * @param {string} action
     * @param {string} label
     */
    function sendCartTransaction(action, label) {
        ga('send', 'event', 'ecommerce', action, label);
    }

    /**
     * addToCart() Sends an event to GA
     * based on the passed model to measure a product being added to cart
     *
     * @param {object} model
     */
    function addToCart(model) {
        if (ensureEcommercePlugin()) {
            var productObject = {
                'name': model.name,
                'variant': model.variant,
                'price': model.price,
                'quantity': model.quantity
            };

            // If id is provided in model, include the passed id
            if (model.id) {
                productObject.id = model.id;
            }

            ga('ec:addProduct', productObject);
            ga('ec:setAction', 'add');
            sendCartTransaction('click', 'addToCart');
        }
    }

    function removeFromCart(model) {
        if (ensureEcommercePlugin()) {
            var productObject = {
                'name': model.name,
                'variant': model.variant,
                'price': model.price,
                'quantity': model.quantity
            };

            // If id is provided in model, include the passed id
            if (model.id) {
                productObject.id = model.id;
            }

            ga('ec:addProduct', productObject);
            ga('ec:setAction', 'remove');
            sendCartTransaction('click', 'removeFromCart');
        }
    }

    /**
     * getCheckoutCart() sets a list of products from an array of products to GA
     *
     * @param {array} products An Array of products in the cart
     */
    function getCheckoutCart(products) {
        if (ensureEcommercePlugin()) {
            for (var i = 0; i < products.length; i++) {
                var product = products[i];
                
                var productObject = {
                    'name': product.itemName,
                    'variant': product.sku,
                    'price': product.price,
                    'quantity': product.quantity
                };

                // If id is provided in model, include the passed id
                if (product.sku || product.externalid || product.id) {
                    productObject.id = product.sku || product.externalid ||product.id;
                }

                ga('ec:addProduct', productObject);
            }
        }
    }

    /**
     * setCheckoutStep() Sends checkout step to ga.
     *
     * @param {array} products List of products in cart
     * @param {string} action
     * @param {integer} step Specifies current checkout step
     * @param {string} option Optional option value for step
     */
    function setCheckoutStep(products, step, isUserInteraction, option) {
        // send when dom is ready
        $(function () {
            if (ensureEcommercePlugin()) {
                // get all products from cart
                getCheckoutCart(products)

                if (option) {
                    ga('ec:setAction', 'checkout', {
                        'step': step,
                        'option': option
                    });
                } else {
                    ga('ec:setAction', 'checkout', {
                        'step': step
                    });
                }

                if (isUserInteraction) {
                    ga('send', 'event', 'ecommerce', 'checkout', 'Checkout Step');
                } else {
                    ga('send', 'event', 'ecommerce', 'checkout', 'Checkout Step', { 'nonInteraction': 1 });
                }
            }
        });
    }

    /**
     * setCheckoutOption() Sends checkout step to ga.
     *
     * @param {integer} step Specifies current checkout step
     * @param {string} option Optional option value for step
     */
    function setCheckoutOption(step, option, callback) {
        // send when dom is ready
        $(function () {
            if (ensureEcommercePlugin()) {
                ga('ec:setAction', 'checkout_option', {
                    'step': step,
                    'option': option
                });

                if (typeof (callback) == 'function') {
                    ga('send', 'event', 'ecommerce', 'checkout', 'Checkout Option', {
                        hitCallback: callback
                    });
                } else {
                    ga('send', 'event', 'ecommerce', 'checkout', 'Checkout Option');
                }
            }
        });
    }

    // purchase report
    function setPurchase(products, purchase) {
        // send when dom is ready
        $(function () {
            if (ensureEcommercePlugin()) {
                _.forEach(products, function (i) {
                    var productObject = {
                        'name': i.name,
                        'price': i.price,
                        'quantity': i.quantity
                    };

                    // If id is provided in model, include the passed id
                    if (i.sku || i.externalid || i.id) {
                        productObject.id = i.sku || i.externalid || i.id;
                    }

                    ga('ec:addProduct', productObject);

                    Logger.debug('Purchase Items ', i)
                });

                var promoCodes = [];
                if (purchase.promotionCodesApplied !== null) {
                    _.forEach(purchase.promotionCodesApplied, function (val, key) {
                        if (purchase.promotionCodesApplied.hasOwnProperty(key)) {
                            promoCodes.push(key);
                        }
                    });
                }

                var coupon = promoCodes.join(', ');

                ga('ec:setAction', 'purchase', {
                    'id': purchase.id,
                    'affiliation': 'Online Store',
                    'revenue': purchase.revenue,
                    'tax': purchase.tax,
                    'shipping': purchase.shipping,
                    'coupon': coupon
                });

                Logger.debug('purchase ', purchase)


                ga('send', 'event', 'ecommerce', 'pageview', 'Purchase', { 'nonInteraction': 1 });
            }
        });
    }

    var GoogleAnalytics = {
        setPurchase: setPurchase,
        setImpression: setImpression,
        setImpressionDetailed: setImpressionDetailed,
        setProductClick: setProductClick,
        setBannerImpression: setBannerImpression,
        setBannerClick: setBannerClick,
        addToCart: addToCart,
        removeFromCart: removeFromCart,
        Checkout: {
            setCheckoutStep: setCheckoutStep,
            setCheckoutOption: setCheckoutOption
        }
    }

    Logger.debug('GoogleAnalytics.js Loaded:', GoogleAnalytics);

    return GoogleAnalytics;
});
